import * as React from 'react';
import { Line } from 'react-chartjs-2';

import { SharedChartRenderProps, getOptions } from './Shared';
import { observer, inject } from 'mobx-react';

type ChartRenderProps = SharedChartRenderProps;

@inject('sensortypes')
@observer
export class ChartRender extends React.Component<ChartRenderProps & {[key: string]: any}> {
    constructor(props: any) {
        super(props);
    }
    public render() {
        const { CurrentChart, sensortypes, unit }  = this.props;
        let { measurementUnit, sensorType } = CurrentChart;
        let sensorTypes = sensortypes.getParsedItems;
        let currentSensorType = sensorTypes.find(o => 
            o.typedId === sensorType
        ) || {};
        const _datasets =  (this.props.data && this.props.data.datasets ? this.props.data.datasets : []);
        const datasets = _datasets.map(o => 
            Object.assign({}, o, {
                fillColor: 'rgba(255,255,255,0)',
                // strokeColor: undefined,
                // highlightFill: undefined,
                // highlightStroke: undefined,
            
                backgroundColor:  'rgba(255,255,255,0)',
                // borderColor: undefined,
                pointBackgroundColor:  'rgba(255,255,255,0)',
                // pointBorderColor:  'rgba(255,255,255,0)',
                // pointHoverBackgroundColor:  'rgba(255,255,255,0)',
                pointHoverBorderColor:  'rgba(255,255,255,0)'
            })
        );

        let data = Object.assign({}, this.props.data, { datasets });
        console.log(data);
        return  (   
            <div className="widget-frame">
                <Line
                    {...this.props}
                    data={data}
                    options={getOptions(CurrentChart, {
                        scales: {
                            xAxes: [{
                                type: 'time',
                                display: true,
                                scaleLabel: {
                                    display: true,
                                    labelString: 'Time',
                                },
                                time: {
                                    displayFormats: {
                                        minute: 'h:mm a',
                                        hour: 'hA',
                                        day: 'Do, hA',
                                        month: 'MMM Do, YYYY'
                                    },
                                    unit
                                }
                            }],
                            yAxes: [{
                                display: true,
                                ticks: {
                                    callback: (val: any) => `${val} ${measurementUnit}`
                                },
                                scaleLabel: {
                                    display: true,
                                    labelString: currentSensorType.name || '',
                                }
                            }]
                        },
                        
                        plugins: {
                            filler: {
                                propagate: false
                            }
                        },
                        elements: {
                            line: {
                                tension: 0, // disables bezier curves
                            }
                        }
                    })}
                />
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/container/Chart/renders/Line.tsx